import selectableUsersGroupUrl from './selectable-users-group.html';

class SelectableUsersGroupCtrl {
  onUserSelect(selectedUser) {
    this.selectedUser = selectedUser;
    this.onSelect({ selectedUser });
  }
}

export default {
  controller: SelectableUsersGroupCtrl,
  controllerAs: 'ctrl',
  bindings: {
    usersGroup: '<',
    onSelect: '&',
  },
  templateUrl: selectableUsersGroupUrl,
};
